// extracted by mini-css-extract-plugin
export default {"addButton":"AddCountry_addButton__z6cQ7","dialog":"AddCountry_dialog__Ggx3X","dialogContent":"AddCountry_dialogContent__lCKQM","dialogFooter":"AddCountry_dialogFooter__tKgc9"};